const firebaseConfig = {
    apiKey: "AIzaSyDJl71PQUIVoIXG6BwsJrg2H8ejs8hYxB4",
    authDomain: "firabase-react-project.firebaseapp.com",
    projectId: "firabase-react-project",
    storageBucket: "firabase-react-project.appspot.com",
    messagingSenderId: "620859821268",
    appId: "1:620859821268:web:92ddd5c389052c21adff41"
  };

  export default firebaseConfig